import { render } from "./PmList.vue?vue&type=template&id=023844ce&scoped=true"
import script from "./PmList.vue?vue&type=script&lang=js"
export * from "./PmList.vue?vue&type=script&lang=js"

import "./PmList.vue?vue&type=style&index=0&id=023844ce&lang=css"
import "./PmList.vue?vue&type=style&index=1&id=023844ce&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023844ce"]])

export default __exports__